import './style.scss';

export function payment_block() {

    const block = document.querySelector('.payment_block');
    if (!block) return;

}
